import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { StreamPersonaTransport, EngineStatus, FaceProfile, HardwareInfo } from "./types";
import { LiveKitTransport } from "./LiveKitTransport";
import { LocalHttpTransport } from "./LocalHttpTransport";
import { isLiteEdition } from "../config";

export * from "./types";
export * from "./LiveKitTransport";
export * from "./LocalHttpTransport";

const TransportContext = createContext<StreamPersonaTransport | null>(null);

let singletonTransport: StreamPersonaTransport | null = null;

export function getTransport(): StreamPersonaTransport {
  if (!singletonTransport) {
    if (isLiteEdition()) {
      singletonTransport = new LiveKitTransport();
    } else {
      singletonTransport = new LocalHttpTransport();
    }
  }
  return singletonTransport;
}

export function TransportProvider({ children }: { children: React.ReactNode }) {
  const transport = useMemo(() => getTransport(), []);
  return React.createElement(TransportContext.Provider, { value: transport }, children);
}

export function useTransport(): StreamPersonaTransport {
  const context = useContext(TransportContext);
  if (context) return context;
  return getTransport();
}
